import { useNavigate } from "@tanstack/react-router";
import type { Row } from "@tanstack/react-table";
import { type MouseEvent, useCallback } from "react";

export const useRowClick = <Item>({
  urlFn,
  selectMode,
  handleRowSelect,
}: {
  urlFn: (item: Item) => string;
  selectMode: boolean;
  handleRowSelect: (row: Row<Item>) => void;
}) => {
  const navigate = useNavigate();
  return useCallback(
    (e: MouseEvent<HTMLElement>, row: Row<Item>) => {
      if (selectMode) {
        document.getSelection()?.removeAllRanges();
        handleRowSelect(row);
        return;
      }
      const url = urlFn(row.original);
      // This is required to simulate default anchor behaviour of opening in new tab
      if (e.ctrlKey || e.metaKey) {
        window.open(url, "_blank", "rel=noopener noreferrer");
      } else {
        void navigate({ to: url });
      }
    },
    [navigate, urlFn, selectMode, handleRowSelect],
  );
};
